import type {ActivityLocationResource, WorkplacePreferenceResourceValue} from '~/types/api-raw-types';
import type {LocationPreferences} from '~/types/domain/LocationPreferences';

export type WorkplaceLocation = {
    city: string;
    radius: number;
    zipCode: string;
};

export type WorkplacePreferences = {
    isRemoteOnly: boolean;
    mainCity: WorkplaceLocation;
    alternativeWorkplaceLocations: WorkplaceLocation[];
    isWillingToTravelInternationally: boolean;
    travelLocations: string[];
};

export function toWorkplacePreferences(preferences: LocationPreferences): WorkplacePreferences {
    return {
        isRemoteOnly: isRemoteOnly(preferences.preference),
        mainCity: {
            city: preferences.address.city,
            radius: preferences.addressRadius,
            zipCode: preferences.address.zipCode,
        },
        alternativeWorkplaceLocations: preferences.activityLocations.map((location) => toWorkplaceLocation(location)),
        isWillingToTravelInternationally: preferences.willingnessToTravelInternationally,
        travelLocations: preferences.travelLocations,
    };
}

function isRemoteOnly(preference: WorkplacePreferenceResourceValue): boolean {
    return preference !== 'ONSITE' && preference !== 'PARTIALLY_ONSITE';
}

function toWorkplaceLocation(location: ActivityLocationResource): WorkplaceLocation {
    return {
        city: location.address.city,
        radius: location.radius,
        zipCode: location.address.zipCode,
    };
}
